import { Tree } from "./kernel";
import { nameToId, TREE } from "./shared";
export function declareAction(name = "action", ...reactions) {
    if (typeof name === "function") {
        reactions.unshift(name);
        name = "action";
    }
    const id = nameToId(name);
    const ACTree = new Tree(id, true);
    const actionCreator = function actionCreator(payload) {
        return {
            type: id,
            payload,
            reactions,
        };
    };
    actionCreator[TREE] = ACTree;
    actionCreator.getType = () => id;
    return actionCreator;
}
